/**
 * Formats a numeric or string value as Nigerian Naira (NGN) currency.
 *
 * @param value Number or string representation of the amount
 * @returns Formatted currency string (e.g., "₦1,250.00")
 */
export const formatCurrency = (value?: number | string | null): string => {
  const numericValue = typeof value === "string" ? parseFloat(value) : value;
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(numericValue && Number.isFinite(numericValue) ? numericValue : 0);
};

/**
 * Formats a numeric or string value to 2 decimal places.
 *
 * @param value Number or string representation of the number
 * @returns Formatted number string (e.g., "1250.00")
 */
export const formatNumber = (value?: number | string | null): string => {
  const numericValue = typeof value === "string" ? parseFloat(value) : value;
  return (numericValue && Number.isFinite(numericValue) ? numericValue : 0).toFixed(2);
};

/**
 * Alias for formatCurrency
 */
export const formatAmount = formatCurrency;
